import React from 'react';
import { Hidden } from '@material-ui/core';
import { stringDateSort } from '../../helpers/sort-helper';
import {  TcsmNewsUpdatesPage } from '../../models/tcsm-page-models';
import { BlockFactory } from '../block-factory';
import { DividerSection } from '../layout/divider-section';
import { MainContent } from '../layout/main-content-container';
import { PageContainer } from '../layout/page-container';
import { PageHeader } from '../layout/page-header';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';
import { GuidedProcessSupportBlock } from '../guided-process-support-block';
import { SideBarContent } from '../layout/sidebar-content';

interface Props {
    pageData: TcsmNewsUpdatesPage,
}

export const TcsmNewsUpdatesPageView = (props: Props) => {
    const { pageData } = props;

    const sortedItems = pageData?.newsUpdatesItems?.sort(function (a, b) {
        return stringDateSort(a.date, b.date);
    });

    return (

        <PageContainer>
            <MainContent>
                <PageHeader
                    headerText={pageData?.pageTitle}
                />
                <Hidden mdUp>
                    <SideBarContent>
                        <GuidedProcessSupportBlock title={pageData?.newsUpdatesGpsTitle} contents={pageData?.newsUpdatesGps} />
                    </SideBarContent>
                </Hidden>
                <DividerSection removeDivider>
                    <div className="news-message">
                        <WysiwygWithReactLink content={pageData?.newsAndUpdatesMessage} />
                    </div>
                </DividerSection>

                <DividerSection removeDivider>
                    <h2>{pageData?.topicsOfInterestHeader}</h2>
                    <div className="news-topics">
                        {
                            sortedItems?.map((a, idx) => <BlockFactory key={idx + a.title} blockData={a} />)
                        }
                    </div>
                </DividerSection>
            </MainContent>

            <SideBarContent>
                <GuidedProcessSupportBlock title={pageData?.newsUpdatesGpsTitle} contents={pageData?.newsUpdatesGps} />
            </SideBarContent>
						
        </PageContainer>
        
    );

};


